import React, { FC, memo, useCallback, useRef, useState } from 'react';
import { Input } from 'components/ui/input';
import { Button } from 'components/ui/button';
import { Card } from 'components/ui/card';
import { useForm } from 'forms/hooks';

export interface ContactRequestsFormValues {
  phone: string;
}

export interface ContactRequestsFormProps {
  onSubmit: (data: ContactRequestsFormValues) => Promise<void>;
  pending?: boolean;
}

export const ContactRequestsForm: FC<ContactRequestsFormProps> = ({
  onSubmit,
  pending = false,
}) => {
  const phoneRef = useRef<HTMLInputElement | null>(null);
  const [disabledSubmit, setDisabledSubmit] = useState<boolean>(true);

  const { values, onChange, errors, setErrors } =
    useForm<ContactRequestsFormValues>({
      phone: '',
    });

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      e.stopPropagation();

      try {
        await onSubmit(values);
      } catch (error) {
        setErrors({
          phone: 'Произошла ошибка при отправке формы',
        });
      }
    },
    [onSubmit, values, setErrors]
  );

  React.useEffect(() => {
    if (values.phone.length <= 9) {
      setDisabledSubmit(true);
    } else {
      setDisabledSubmit(false);
    }

    if (values.phone.length === 0) {
      setErrors({
        phone: '',
      });
    }
  }, [values, setDisabledSubmit, setErrors]);

  return (
    <Card className="w-full max-w-md mx-auto p-8">
      <span className="font-medium text-2xl text-[#424242] mb-3 block">
        Введите номер
      </span>
      <span className="font-normal text-base text-[#424242] mb-6 block">
        чтобы получить актуальные цены
      </span>
      <form onSubmit={handleSubmit}>
        <div className="my-6 flex flex-col gap-2">
          <label htmlFor="phone" className="text-sm font-medium mb-1">
            Номер телефона
          </label>
          <Input
            id="phone"
            disabled={pending}
            onChange={(e) => {
              let value = e.target.value.replace(/\D/g, '').slice(0, 10);
              onChange(value, 'phone');
            }}
            value={values.phone}
            name="phone"
            placeholder="(777) 777 77 77"
            ref={phoneRef}
          />
          {errors.phone && (
            <span className="text-red-500 text-xs mt-1">{errors.phone}</span>
          )}
        </div>
        <Button
          type="submit"
          className="w-full h-13 mt-6"
          disabled={disabledSubmit || pending}
        >
          {pending ? 'Отправка...' : 'Отправить'}
        </Button>
      </form>
    </Card>
  );
};

export default memo(ContactRequestsForm);
